import { attempt } from '@shared/utils'
import { logger } from '@shared/lib/logger'

const globalChannelProviderApi: string = 'GLOBAL_CHANNEL_PROVIDER_API'
const globalChannelProviderApiKey: string = 'GLOBAL_CHANNEL_PROVIDER_API_KEY'

const TENANT = 'vistaprint'
const FEATURE = 'ContactUsPage'

export interface ChatStatus {
  isChatEnabled: boolean
  remainingTime?: number
  TTL: number
}

interface ChatStatusApiResponse {
  status: ChatStatus
}

/**
 * Fetches the chat channel status (business hours) from the Global Channel
 * Provider Service.
 *
 * Returns `null` on any network or HTTP error so callers can treat an unknown
 * status safely (i.e. not fire the OOBH tracking event).
 */
export const fetchChatStatus = async (locale: string): Promise<ChatStatus | null> => {
  const url = `${globalChannelProviderApi}/v3/channels/chat?tenant=${TENANT}&locale=${locale}&feature=${FEATURE}`

  const { data: response, error: fetchError } = await attempt(
    fetch(url, {
      method: 'GET',
      headers: {
        'x-api-key': globalChannelProviderApiKey,
      },
    }),
  )

  if (fetchError) {
    logger.error('Error fetching chat status', {
      action: 'fetch_chat_status_failed',
      component: 'fetchChatStatus',
      locale,
      errorMessage: JSON.stringify(fetchError),
    })
    return null
  }

  if (!response.ok) {
    logger.error('Error fetching chat status', {
      action: 'fetch_chat_status_http_error',
      component: 'fetchChatStatus',
      locale,
      errorMessage: `HTTP error! Status: ${response.status}`,
    })
    return null
  }

  const data = (await response.json()) as ChatStatusApiResponse
  return data.status
}
